import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAspectRatio11 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M16.1992 9C16.1992 8.33726 15.6618 7.7998 14.999 7.7998H8.99902C8.33628 7.7998 7.79883 8.33726 7.79883 9V15C7.79883 15.6627 8.33628 16.2002 8.99902 16.2002H14.999C15.6618 16.2002 16.1992 15.6627 16.1992 15V9ZM17.7988 15C17.7988 16.5464 16.5454 17.7998 14.999 17.7998H8.99902C7.45263 17.7998 6.19922 16.5464 6.19922 15V9C6.19922 7.4536 7.45263 6.2002 8.99902 6.2002H14.999C16.5454 6.2002 17.7988 7.4536 17.7988 9V15Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgAspectRatio11);
export default ForwardRef;
